import { Component, OnInit } from "@angular/core";
import { Location } from "@angular/common";
import Swal from "sweetalert2";
import { ApiService } from "../../../service/apiServices";
import { ActivatedRoute } from "@angular/router";
import * as $ from "jquery";
import { Global } from "src/app/global";
import { AuthService } from "src/app/service/auth/auth.service";
@Component({
  selector: "app-plan",
  templateUrl: "./plan.component.html",
  styleUrls: ["./plan.component.css"],
})
export class PlanComponent implements OnInit {
  plano: any = {};
  addValores: boolean = false;

  //procedimento
  listaProcedimentos: any = [];

  //consulta
  listaOcupacoes: any = [];

  //paginação procedimentos
  paginaProcedimentos: any = 1;
  totalPaginasProcedimentos: any = 1;
  //paginação consultas
  paginaConsultas: any = 1;
  totalPaginasConsultas: any = 1;
  totalPorPagina: any = 25;
  lockBTN: boolean = true;

  ano: number = new Date().getFullYear();

  meses = {
    janeiro: 0,
    fevereiro: 0,
    marco: 0,
    abril: 0,
    maio: 0,
    junho: 0,
    julho: 0,
    agosto: 0,
    setembro: 0,
    outubro: 0,
    novembro: 0,
    dezembro: 0,
  };

  constructor(
    private location: Location,
    private route: ActivatedRoute,
    private service: ApiService,
    private global: Global,
    private authService: AuthService
  ) {}

  ngOnInit() {
    var uid = this.route.snapshot.paramMap.get("uuid");
    this.plano.ativo = true;
    if (uid != null) {
      Swal.fire("Favor aguarde");
      Swal.showLoading();
      this.obterPlano(uid).then(
        (result) => {
          this.plano = result;
          if (this.plano.id) {
            this.obterTetoMes();
            this.addValores = true;
          }
          Swal.close();
        },
        (error) => {
          console.log(error);
          Swal.close();
        }
      );
    }
  }

  obterPlano = (uid) => {
    return new Promise((res, rej) => {
      this.service.Get(`Plano/${uid}`).then(
        (result) => {
          res(result);

          this.plano = result;
          if (
            this.plano.senha_alterada_em != undefined ||
            this.plano.senha_alterada_em != null
          ) {
            this.plano.senha_login = "****";
          }
          if (this.plano.telefone != undefined || this.plano.telefone != null) {
            if (this.plano.telefone.length === 10) {
              this.plano.telefone = this.plano.telefone.replace(
                /(\d{2})(\d{4})(\d{0,4})/,
                "($1) $2-$3"
              );
            } else if (this.plano.telefone.length === 11) {
              this.plano.telefone = this.plano.telefone.replace(
                /(\d{2})(\d{5})(\d{0,4})/,
                "($1) $2-$3"
              );
            }
          }

          this.checkCadastroValidoPlano();
        },
        (error) => {
          rej(error);
        }
      );
    });
  };

  mudaStatusPlano = () => {
    this.plano.ativo != this.plano.ativo;
  };

  salvarPlano = () => {
    Swal.fire("Favor aguarde");
    Swal.showLoading();

    if (!this.plano.nome || this.plano.nome == "") {
      Swal.fire("Erro", "É preciso informar o nome para o plano", "error");
      return;
    }
    var obj = {
      ativo: this.plano.ativo,
      nome: this.plano.nome,
      cnpj: this.plano.cnpj,
      senha_md5: this.global.MD5(this.plano.senha_login),
      email: this.plano.email,
      telefone: this.plano.telefone,
      quantidade_max_consultas_mensais: this.plano.quantidade_max_consultas_mensais,
      agrupar_teto_mensal : this.plano.agrupar_teto_mensal || false
    };
    this.service.Post(`Plano`, obj).then(
      (result) => {
        this.plano = result;
        if (this.plano.id) {
          this.addValores = true;
        }
        Swal.fire("Sucesso", "Plano cadastrado com sucesso", "success");
      },
      (error) => {
        if (error.error && error.error.messagem) {
          Swal.fire("Erro", error.error.messagem, "error");
        } else {
          Swal.fire("Erro", error.messagem, "error");
        }
      }
    );
  };

  goBack() {
    this.location.back();
  }
  editarPlano = () => {
    Swal.fire("Favor aguarde");
    Swal.showLoading;

    if (
      this.plano.senha_login.length > 0 &&
      this.plano.senha_login.trim() != "****"
    )
      this.plano.senha_md5 = this.global.MD5(this.plano.senha_login);

    this.service.Put(`Plano/${this.plano.id}`, this.plano).then(
      (result) => {
        Swal.fire("Sucesso", "Plano alterado com sucesso", "success");
      },
      (error) => {
        this.emitError(error);
      }
    );
  };
  emitError = (error) => {
    if (typeof error == "string") {
      Swal.fire("Erro", `${error}`, "error");
      return;
    }
    if (error.status == 401 || error.error.status == 401) {
      Swal.close();
      return;
    }
    if (error.error.erros) {
      Swal.fire("Erro", `${error.error.erros[0].messagem}`, "error");
      return;
    }
    if (error.status) {
      Swal.fire("Erro", `${error.status} - ${error.statusText}`, "error");
      return;
    }
    if (error.alert) {
      Swal.fire("Atenção", `${error.txt}`, "warning");
      return;
    }
  };

  obterProcedimentos = () => {
    this.listaProcedimentos = [];
    Swal.fire("Favor aguarde");
    Swal.showLoading();
    this.service
      .Get(`PlanoSigTap?Skip=0&Take=${this.totalPorPagina}&Ativo=true`)
      .then(
        (result) => {
          var lista = result["conteudo"];
          for (let item of lista) {
            if (item.plano_id == this.plano.id) {
              this.listaProcedimentos.push(item);
            }
          }
          Swal.close();
        },
        (error) => {
          if (error.error && error.error.messagem) {
            Swal.fire("Erro", error.error.messagem, "error");
          } else {
            Swal.fire("Erro", error.messagem, "error");
          }
        }
      );
  };

  obterConsultas = () => {
    this.listaOcupacoes = [];
    Swal.fire("Favor aguarde");
    Swal.showLoading();
    this.service
      .Get(`PlanoOcupacao?Skip=0&Take=${this.totalPorPagina}&Ativo=true`)
      .then(
        (result) => {
          var lista = result["conteudo"];
          for (let item of lista) {
            if (item.plano_id == this.plano.id) {
              this.listaOcupacoes.push(item);
            }
          }
          Swal.close();
        },
        (error) => {
          if (error.error && error.error.messagem) {
            Swal.fire("Erro", error.error.messagem, "error");
          } else {
            Swal.fire("Erro", error.messagem, "error");
          }
        }
      );
  };

  addNovoProcedimento = () => {
    $("#modalAddProcedimento").addClass("show");
    $("#modalAddProcedimento").css("display", "block");
  };

  addNovaConsulta = () => {
    $("#modalAddConsulta").addClass("show");
    $("#modalAddConsulta").css("display", "block");
  };

  atualizaListaProcedimentos = (item: boolean) => {
    if (item) {
      this.obterProcedimentos();
    }
  };

  atualizaListaEspecialidades = (item: boolean) => {
    if (item) {
      this.obterConsultas();
    }
  };

  validaDados = (item) => {
    return new Promise((resolve, reject) => {
      if (!item.novoValor || item.novoValor <= 0 || item.novoValor == "") {
        reject("É preciso informar um valor para o procedimento");
        return;
      }
      if (item.novoValor) {
        if (item.novoValor.includes(","))
          item.novoValor = item.novoValor.replace(",", ".");
        item.novoValor = parseFloat(item.novoValor);
      }
      resolve(item);
    });
  };

  editarValorProcedimento = (item) => {
    item.editar = true;
    item.novoValor = item.valor;
  };

  salvarEditarProcedimento = (item) => {
    Swal.fire("Favor aguarde");
    Swal.showLoading();
    this.validaDados(item).then(
      (result) => {
        var obj: any = {};
        Object.assign(obj, result);
        obj.valor = obj.novoValor;
        delete obj.editar;
        delete obj.novoValor;
        this.service.Put(`PlanoSigTap/${obj.id}`, obj).then(
          (result) => {
            Swal.fire(
              "Sucesso",
              "Procedimento editado com sucesso",
              "success"
            ).then((result) => {
              this.atualizaListaProcedimentos(true);
            });
          },
          (error) => {
            Swal.fire("Erro", error.messagem, "error");
          }
        );
      },
      (error) => {
        if (error.error && error.error.messagem) {
          Swal.fire("Erro", error.error.messagem, "error");
        } else {
          Swal.fire("Erro", error.messagem, "error");
        }
      }
    );
  };

  editarValorEspecialidade = (item) => {
    item.editar = true;
    item.novoValor = item.valor;
  };

  salvarEditarEspecialidade = (item) => {
    Swal.fire("Favor aguarde");
    Swal.showLoading();
    this.validaDados(item).then(
      (result) => {
        var obj: any = {};
        Object.assign(obj, result);
        obj.valor = obj.novoValor;
        delete obj.editar;
        delete obj.novoValor;
        obj.ocupacao_id = result["sigtap_id"];
        this.service.Put(`PlanoOcupacao/${obj.id}`, obj).then(
          (result) => {
            Swal.fire(
              "Sucesso",
              "Especialidade editada com sucesso",
              "success"
            ).then((result) => {
              this.atualizaListaEspecialidades(true);
            });
          },
          (error) => {
            Swal.fire("Erro", error.messagem, "error");
          }
        );
      },
      (error) => {
        if (error.error && error.error.messagem) {
          Swal.fire("Erro", error.error.messagem, "error");
        } else {
          Swal.fire("Erro", error.messagem, "error");
        }
      }
    );
  };

  cancelarEditar = (item) => {
    delete item.editar;
  };

  obterListaProcedimentosPaginada = (pagina) => {
    this.listaOcupacoes = [];
    Swal.fire("Favor aguarde");
    Swal.showLoading();
    this.service
      .Get(`PlanoSigTap?Skip=${pagina}&Take=${this.totalPorPagina}&Ativo=true`)
      .then(
        (result) => {
          var lista = result["conteudo"];
          for (let item of lista) {
            if (item.plano_id == this.plano.id) {
              this.listaOcupacoes.push(item);
            }
          }
          Swal.close();
        },
        (error) => {
          Swal.fire("Erro", error.messagem, "error");
        }
      );
  };

  obterListaEspecialidadesPaginada = (pagina) => {
    this.listaOcupacoes = [];
    Swal.fire("Favor aguarde");
    Swal.showLoading();
    this.service
      .Get(
        `PlanoOcupacao?Skip=${pagina}&Take=${this.totalPorPagina}&Ativo=true`
      )
      .then(
        (result) => {
          var lista = result["conteudo"];
          for (let item of lista) {
            if (item.plano_id == this.plano.id) {
              this.listaOcupacoes.push(item);
            }
          }
          Swal.close();
        },
        (error) => {
          if (error.error && error.error.messagem) {
            Swal.fire("Erro", error.error.messagem, "error");
          } else {
            Swal.fire("Erro", error.messagem, "error");
          }
        }
      );
  };

  checkCadastroValidoPlano(): void {
    if (
      this.validarCNPJ() &&
      this.plano.nome.length >= 3 &&
      this.plano.senha_login.length >= 3
    ) {
      this.lockBTN = false;
    } else {
      this.lockBTN = true;
    }
  }

  validarCNPJ(): boolean {
    var cnpj = this.plano.cnpj;

    if (cnpj == undefined) return false;
    const cleanCNPJ = cnpj.replace(/[^\d]/g, "");

    if (cleanCNPJ.length !== 14) return false;

    if (/^(\d)\1+$/.test(cleanCNPJ)) return false;

    const calcDV = (base: string, weights: number[]): number => {
      const sum = base.split("").reduce((acc, digit, index) => {
        return acc + parseInt(digit) * weights[index];
      }, 0);
      const remainder = sum % 11;
      return remainder < 2 ? 0 : 11 - remainder;
    };

    const baseCNPJ = cleanCNPJ.substring(0, 12);
    const firstDV = calcDV(baseCNPJ, [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]);
    const secondDV = calcDV(
      baseCNPJ + firstDV,
      [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
    );

    return cleanCNPJ === baseCNPJ + firstDV.toString() + secondDV.toString();
  }
  mascaraTelefone() {
    const elemento = document.getElementById(
      "telefone_plano_id"
    ) as HTMLInputElement;
    let valor = elemento.value.replace(/\D/g, "");
    if (valor.length === 10) {
      valor = valor.replace(/(\d{2})(\d{4})(\d{0,4})/, "($1) $2-$3");
    } else if (valor.length === 11) {
      valor = valor.replace(/(\d{2})(\d{5})(\d{0,4})/, "($1) $2-$3");
    }
    elemento.value = valor;
  }
  obterTetoMes() {
    this.service
      .Get(`PlanoTetoMensal/Plano/${this.plano.id}/Ano/${this.ano}`)
      .then(
        (data: any[]) => {
          // limpa os valores atuais
          Object.keys(this.meses).forEach((m) => (this.meses[m] = 0));

          // percorre o retorno da API e atualiza os campos
          data.forEach((item) => {
            switch (item.mes_nome.toLowerCase()) {
              case "janeiro":
                this.meses.janeiro = item.quantidade_max_consultas;
                break;
              case "fevereiro":
                this.meses.fevereiro = item.quantidade_max_consultas;
                break;
              case "março":
              case "marco":
                this.meses.marco = item.quantidade_max_consultas;
                break;
              case "abril":
                this.meses.abril = item.quantidade_max_consultas;
                break;
              case "maio":
                this.meses.maio = item.quantidade_max_consultas;
                break;
              case "junho":
                this.meses.junho = item.quantidade_max_consultas;
                break;
              case "julho":
                this.meses.julho = item.quantidade_max_consultas;
                break;
              case "agosto":
                this.meses.agosto = item.quantidade_max_consultas;
                break;
              case "setembro":
                this.meses.setembro = item.quantidade_max_consultas;
                break;
              case "outubro":
                this.meses.outubro = item.quantidade_max_consultas;
                break;
              case "novembro":
                this.meses.novembro = item.quantidade_max_consultas;
                break;
              case "dezembro":
                this.meses.dezembro = item.quantidade_max_consultas;
                break;
            }
          });
        },
        (error) => {
          if (error.status == 401 || error.error.status == 401) {
            Swal.close();
            this.authService.logoutUser();
          }
          if (error.error && error.error.messagem) {
            Swal.fire("Erro", error.error.messagem, "error");
          } else {
            Swal.fire("Erro", error.messagem, "error");
          }
        }
      );
  }

  onAnoChange(value: number) {
    this.ano = value;
    if (this.plano && this.plano.id) {
      this.obterTetoMes();
    }
  }

  salvarTetoMes() {
    const request = {
      planoId: this.plano.id,
      agrupado: false,
      ano: this.ano,
      tetos: [
        { mes: "JANEIRO", quantidadeMaxConsultas: this.meses.janeiro || 0 },
        { mes: "FEVEREIRO", quantidadeMaxConsultas: this.meses.fevereiro || 0 },
        { mes: "MARCO", quantidadeMaxConsultas: this.meses.marco || 0 },
        { mes: "ABRIL", quantidadeMaxConsultas: this.meses.abril || 0 },
        { mes: "MAIO", quantidadeMaxConsultas: this.meses.maio || 0 },
        { mes: "JUNHO", quantidadeMaxConsultas: this.meses.junho || 0 },
        { mes: "JULHO", quantidadeMaxConsultas: this.meses.julho || 0 },
        { mes: "AGOSTO", quantidadeMaxConsultas: this.meses.agosto || 0 },
        { mes: "SETEMBRO", quantidadeMaxConsultas: this.meses.setembro || 0 },
        { mes: "OUTUBRO", quantidadeMaxConsultas: this.meses.outubro || 0 },
        { mes: "NOVEMBRO", quantidadeMaxConsultas: this.meses.novembro || 0 },
        { mes: "DEZEMBRO", quantidadeMaxConsultas: this.meses.dezembro || 0 },
      ],
    };

    this.service.Post(`PlanoTetoMensal/TetoMensal`, request).then(
      (result) => {
        //this.ano = new Date().getFullYear();
        //Object.keys(this.meses).forEach((m) => (this.meses[m] = 0));
        Swal.fire("Sucesso", "Teto mensal salvo com sucesso", "success");
      },
      (error) => {
        if (error.error && error.error.messagem) {
          Swal.fire("Erro", error.error.messagem, "error");
        } else {
          Swal.fire("Erro", error.messagem, "error");
        }
      }
    );
  }
}
